module.exports = __webpack_public_path__ + "static/media/d1.edbf3ff8.jpg";